<template>
  <div class="container">
      <Menu/>
    <router-view />
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
export default {
  name: "MenuLayout",
  components: {
    Banner,
    Menu,
    Footer,
  },
  data(){
    return{
    }
  },
  methods:{}
};
</script>

<style scoped>
.container {
  background: linear-gradient(
    180deg,
    rgb(59, 143, 238) 7%,
    rgb(155, 216, 243) 100%
  );
}
</style>